export default {
    
    indexOccurrenceSheetSchedules:      { method: 'get',    url: 'occurrence_sheet_schedules' },
    createOccurrenceSheetSchedule:      { method: 'post',   url: 'occurrence_sheet_schedules'},
    updateOccurrenceSheetSchedule:      { method: 'put',    url: 'occurrence_sheet_schedules/{id}'},
    deleteOccurrenceSheetSchedule:      { method: 'delete', url: 'occurrence_sheet_schedules/{id}'},
    deleteOccurrenceSheetSchedule:      { method: 'delete', url: 'occurrence_sheet_schedules/{id}'},
    indexOccurrenceSheetScheduleTypes:  { method: 'get',    url: 'occurrence_sheets/scheduleTypes'}
   
}